<div class="row">
  <div class="col pb-5">
    <h6><strong>Forbidden</strong></h6>
  </div>
</div>
<div class="row">
  <div class="col-md-1">

  </div>
  <div class="col-md">
    <img src="design/images/Forbidden.png" class="forb-img" />
    <h1>OOPSSS!!!! Sorry...</h1>
    <p>Sorry, your access is refused due to security reasons of our server and also our sensitive data.</p>
    <a routerLink="/home"><button class="btn btn-secondary mb-5">Home</button></a>
  </div>
</div>
